<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19.773 19.774">
    <g id="Group_25491" data-name="Group 25491" transform="translate(9236.588 6997.887)">
      <g id="Group_25488" data-name="Group 25488" transform="translate(-4650.588 -5543.887)">
        <path id="Path_18124" data-name="Path 18124" d="M20.774,11.887A8.887,8.887,0,1,1,11.887,3,8.887,8.887,0,0,1,20.774,11.887Z" transform="translate(-4588 -1456)" fill="none" stroke="#236ca3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        <path id="Path_18125" data-name="Path 18125" d="M18,21.555V18" transform="translate(-4594.113 -1462.113)" fill="none" stroke="#236ca3" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
        <path id="Path_18126" data-name="Path 18126" d="M18,12h0" transform="translate(-4594.113 -1459.668)" fill="none" stroke="#236ca3" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
      </g>
    </g>
  </svg>
</template>
<script>
import { useBrand } from '@/composables/useBrand';
import md5 from 'js-md5';

export default {
  name: "infoIcon",
  setup() {
    const { getBrandConfiguration, detectBrand } = useBrand();
    return { getBrandConfiguration, detectBrand };
  },
  props: {
    lang: { type: String, default: 'en' },
    translations: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      brandConfig: null,
    };
  },
  methods: {
    getBrandText(key, fallback = '') {
      if (!this.brandConfig) return fallback;
      return this.brandConfig.icons?.[key] || fallback;
    },
    hasSpecialFeature(feature) {
      if (!this.brandConfig) return false;
      return this.brandConfig.features?.[feature] || false;
    },
    getrans(key, brandId = null, lang = null) {
      const finalBrandId = brandId || this.detectBrand() || 'DEFAULT';
      const finalLang = lang || this.lang || 'en';
      const translationKey = md5(`${finalBrandId}_${finalLang}_${key}`);
      return this.translations[translationKey] || key;
    },
  },
  mounted() {
    this.brandConfig = this.getBrandConfiguration();
  },
};
</script>

<style lang="scss">
#Icon_awesome-map-marker-alt {
  fill: var(--result_map_info_svg_color,#236ca3);
}

#Path_18125, #Path_18126 {
  stroke: var(--result_map_info_svg_color,#236ca3);
}
#Path_18124 {
  stroke: var(--result_map_info_svg_color,#236ca3);
}

// .result__button-secondary {
//   #Icon_awesome-map-marker-alt {
//     fill: var(--result_button_secondary_font_color,#0a3b74);
//   }
//   #Path_18125, #Path_18126 {
//     stroke: var(--result_button_secondary_font_color,#0a3b74);
//   }
// }


</style>




